import React, { Component } from 'react';
import { Tooltip } from 'antd';
import { Icon } from 'libs';
import plugin from 'plugin';
class FullScreenComponent extends Component {
    constructor (props) {
        super(props);
    }
    _getFull = () => {
        return window.top.document.fullscreen || window.top.document.mozFullScreen || window.top.document.webkitIsFullScreen || window.top.document.msFullscreenElement;
    }
    componentDidMount () {
        if (plugin.playMode === 'h5') {
            ['fullscreenchange','webkitfullscreenchange','mozfullscreenchange','msfullscreenchange'].forEach((item, index) => {
                document.addEventListener(item, () => this._fullscreenchange(), false);
            });
        }
    }
    _fullscreenchange = () => {
        if(this._getFull()) {
            return;
        } else {
            this._exitfullScreen();
        }
    }
    _toggleFullScreen = () => {
        let {webCaps} = this.props;
        if(plugin.playMode === 'h5') {
            if(!webCaps.hideH5PlayerV4_0) {
                if (this._getFull()) {
                    this._exitfullScreen();
                } else {
                    this._setfullScreen();
                }
            } else {
                plugin.ShowHightOCXTip();
            }
        } else {
            plugin.SetFullscreen(true);
        }
    }
    _setfullScreen = (docElm = window.top.document.documentElement) => {
        if (docElm.requestFullScreen) {
            docElm.requestFullScreen();
        } else if (docElm.mozRequestFullScreen) {
            docElm.mozRequestFullScreen();
        } else if (docElm.webkitRequestFullScreen) {
            docElm.webkitRequestFullScreen();
        } else if (docElm.msRequestFullscreen) {
            docElm.msRequestFullscreen();
        }
        plugin.SetFullscreen(true);
    }
    _exitfullScreen = (docElm = window.top.document.documentElement) => {
        plugin.SetFullscreen(false);
        let {videoRef} = this.props;
        if (docElm.exitFullscreen) {
            docElm.exitFullscreen();
        } else if (docElm.mozCancelFullScreen) {
            docElm.mozCancelFullScreen();
        } else if (docElm.webkitCancelFullScreen) {
            docElm.webkitCancelFullScreen();
        }else if(docElm.msExitFullscreen) {
            docElm.msExitFullscreen();
        }
        plugin.cover(videoRef.current);
    }
    render () {
        let { $t } = this.props;
        return (
            <Tooltip title={$t('com.FullScreen')} placement='left' mouseLeaveDelay={0}>
                <Icon type='fullscreen' onClick = {this._toggleFullScreen}/>
            </Tooltip>
        );
    }
}

export default FullScreenComponent;